import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { Cargo } from '../page/cargo/cargo';

@Injectable({ providedIn: 'root' })
export class CargoService {

  private apiURL = environment.apiBaseUrl + 'cargo';

  constructor(private http: HttpClient) { }

  listar(): Observable<Cargo[]> {
    return this.http.get<Cargo[]>(this.apiURL);
  }

  listarAtivos(departamentoId?: number | null): Observable<Cargo[]> {
    let params = new HttpParams();
    if (departamentoId) {
      params = params.set('departamentoId', departamentoId);
    }
    return this.http.get<Cargo[]>(`${this.apiURL}/ativos`, { params });
  }

  buscarPorId(id: number): Observable<Cargo> {
    return this.http.get<Cargo>(`${this.apiURL}/${id}`);
  }

  salvar(cargo: Cargo): Observable<Cargo> {
    if (cargo.id) {
      return this.http.put<Cargo>(`${this.apiURL}/${cargo.id}`, cargo);
    }
    return this.http.post<Cargo>(this.apiURL, cargo);
  }

  inativar(id: number): Observable<void> {
    return this.http.delete<void>(`${this.apiURL}/${id}`);
  }
}
